// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import authServices from '../services/AuthServices';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({ isAuthenticated: false, user: null, loading: true });
  const [user, setUser] = useState({ role: '' });

  useEffect(() => {
    const checkAuth = () => {
      const token = authServices.getToken();
      const userRole = localStorage.getItem('UserRole');

      if (token && userRole) {
        // Valid token exists, set authenticated state
        setUser({ role: userRole });
        setAuthState({
          isAuthenticated: true,
          user: { name: localStorage.getItem('UserName') },
          loading: false
        });
      } else {
        // No token exists, ensure clean state and redirect
        authServices.logout();
        setAuthState({ isAuthenticated: false, user: null, loading: false });
        // Only redirect if not already on auth pages
        const authPaths = ['/', '/login', '/signup', '/forgot-password', '/verify-otp', '/reset-password'];
        const currentPath = window.location.pathname;
        if (!authPaths.some(path => currentPath === path || currentPath.startsWith('/signup'))) {
          window.location.href = '/';
        }
      }
    };

    checkAuth();
  }, []);

  const login = (response) => {
    const { user, token } = response;
    localStorage.setItem('authToken', token);
    localStorage.setItem('UserRole', user.role);
    localStorage.setItem('UserName', user.name);
    localStorage.setItem('UserMobile', user.mobile);
    localStorage.setItem('user', JSON.stringify({
      role: user.role,
      name: user.name,
      mobile: user.mobile
    }));
    setUser({ role: user.role });
    setAuthState({ isAuthenticated: true, user: { name: user.name }, loading: false });
  };

  const logout = () => {
    authServices.logout();
    setUser({ role: '' });
    setAuthState({ isAuthenticated: false, user: null, loading: false });
    window.location.href = '/';
  };

  const refreshToken = async () => {
    const result = await authServices.refreshToken();
    if (result.success) {
      // Token refreshed successfully, auth state remains the same
      return true;
    } else {
      // Refresh failed, logout user
      logout();
      return false;
    }
  };

  return (
    <AuthContext.Provider value={{ authState, login, logout, user, setUser, refreshToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
